<!-- 页面底部证书&风险提示 -->
<template>
  <div class="page-footer">
    <div class="img-group row">
      <img v-for="(item, index) in imageArr" :src="item" :key="index" />
    </div>
    <div class="safe-tip row" @click="$goFundApp">
      <img :src="safeIcon" class="safe-icon" />
      <div>天天基金安全保障</div>
      <img :src="RIGHT_ARROW" class="arrow" />
    </div>
    <div class="data-source">数据来源：东方财富Choice数据</div>

    <div class="risk-tip">
      <div class="title row">
        <div class="line"></div>
        <div>风险提示</div>
        <div class="line"></div>
      </div>
      <p class="content"
        >基金的过往业绩不预示其未来表现，相关数据仅供参考，不构成投资建议。投资人请详阅<span class="link"
        @click="$goFundApp">基金合同和基金招募说明书</span>。并自行承担投资基金的风险。</p>
    </div>
  </div>
</template>

<script>
export default {

  name: 'page-footer',

  data() {
    return {
      imageArr: [
        'https://j5.dfcfw.com/sc/image/202207/20220707082459.png',
        'https://j5.dfcfw.com/sc/image/202207/20220707082545.png',
        'https://j5.dfcfw.com/sc/image/202207/20220707082324.png',
      ],
      safeIcon: 'https://j5.dfcfw.com/sc/image/202207/20220707091129.png',
      RIGHT_ARROW: 'https://j5.dfcfw.com/sc/image/202207/20220707091149.png',
    };
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.page-footer {
  width: 100%;
  margin-top: 24px;
  padding-bottom: 248px;
  box-sizing: border-box;
  .img-group {
    margin-bottom: 48px;
    justify-content: space-around;
    img {
      width: 160px;
      height: 160px;
    }
  }
  .safe-tip {
    font-size: 28px;
    color: #83a6cf;
    justify-content: center;
    .safe-icon {
      margin-right: 10px;
      width: 36px;
      height: 36px;
    }
    .arrow {
      width: 32px;
      height: 32px;
      margin-left: 8px;
    }
  }
  .data-source {
    margin-top: 30px;
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #999999;
    text-align: center;
  }
  .risk-tip {
    margin-top: 30px;
    .title {
      font-size: 26px;
      color: #cccccc;
      text-align: center;
      .line {
        flex: 1;
        height: 1px;
        background-color: #cccccc;
      }
    }
    .content {
      font-size: 26px;
      line-height: 40px;
      text-align: center;
      color: #999999;
      .link {
        color: #3a90fa;
      }
    }
  }
}
</style>
